<template>

    <div v-if="this.servId =this.servizio.id">
      <h5 class="text-center">Elenco segnalazioni</h5>
      <h4 v-if="this.segnalazioni.length===0" class="text-center"> - nessuna segnalazione - </h4>

      <ul class="list-group-flush ">
        <li class="list-group-item px-6"
          v-for="segnalazione in segnalazioni"
          :key="segnalazione.id">
         <card-segnalazione  :segnalazione="segnalazione"/></li>
      </ul>
    </div>

</template>

<script>

import SegnalazioniDataService from '@/service/SegnalazioniDataService.js'
import cardSegnalazione from './card-segnalazione.vue'

export default {
  name: 'segnalazioni-list',
  components: { cardSegnalazione },
  props: {
    servizio: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      servId: this.$route.params.Sid,
      segnalazioni: []

    }
  },
  methods: {
    caricaSegnalazioni (ids) {
      return SegnalazioniDataService
        .getSegnalazioniByServizioId(ids)
        .then(response => {
          console.log(response.data)
          return response.data
        })
        .catch(e => {
          console.log(e)
          return []
        })
    }
  },
  mounted () {
    console.log('MOUNT', this.servizio)
  },
  watch: {
    servizio: function (NewServizio, OldServizio) {
      console.log('OLD -->', OldServizio)
      console.log('NEW -->', NewServizio)
      if (NewServizio.id) {
        this.caricaSegnalazioni(NewServizio.id).then(risultato => {
          console.log(risultato)
          this.segnalazioni = risultato
        })
      }
    }
  }
}
</script>
